import 'twin.macro';
import 'styled-components/macro';

import { Markdown } from 'component-lib/molecules/markdown/Markdown';

const ConsentLabel = ({ children, ...rest }: { children: string }) => (
  <Markdown allowedElements={['a']} tw="text-primary-medium text-xs [a]:(link)" unwrapDisallowed {...rest}>
    {children}
  </Markdown>
);

export default ConsentLabel;
